import axios from 'axios';
import { UserInfo } from '../store/user-info.type';
import { sgwtConnect } from './sgwt-connect';

export const fetchInfo = async (): Promise<UserInfo> => {
  try {
    const userInfo = await axios.get(`${import.meta.env.VITE_APP_SG_CONNECT_ENDPOINT}/oauth2/userinfo`,
      {
        headers: {
          Authorization: sgwtConnect.getAuthorizationHeader() || null,
        },
      },
    );
    return userInfo.data;
  } catch (error) {
    throw Error('Error during getting current user info');
  }
};

export default {
  fetchInfo,
};
